/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import about from '../assets/about.webp'           
import grayStar from '../assets/shapes/black-star.png'
import greenArrow from '../assets/shapes/left-green-arrow.png'
import { Link } from "react-router-dom";
import { scrollToTop } from "../constent/helper";
export const IntroSection = () => {
  return (
    <div className="intro home-container md:px-8">
      <div className="intro__content flex justify-between md:flex-row flex-col md:gap-10 gap-[30px] ">
        <div className="flex  items-end justify-center md:w-1/2 w-full ">
        <div className="relative flex items-center justify-center">
        <img src={grayStar} className="w-16 h-16 absolute left-[-4%] bottom-[-10%] z-0" alt="" />
          
          <img
            src={about}
            className="w-auto max-h-[550px] h-auto object-contain z-10 "
          />
          <img src={greenArrow} className="w-6 h-6 top-[-4%] right-[-4%] absolute" alt="" />
          </div>
        </div>

        <div className="intro__main h-max md:w-1/2 w-full">
          <div className="font-roboto lg:text-[42px] lg:leading-[60px] md:text-4xl md:leading-[50px] text-2xl leading-[36px] text-justify font-bold">
            Trusted by Thousands, Committed to Humanity
          </div>
          <div className="font-roboto md:my-6 my-4 text-justify text-gray">
            Khadim Welfare Foundation (KWF) is more than a non-profit; it's a
            lifeline for countless needy families in Pakistan. Rooted in love
            for humanity and a mission to serve everyone without discrimination,
            KWF works tirelessly to provide hope and dignity to the most
            vulnerable. Every day, thousands of people rely on KWF's welfare
            services to live with respect and dignity. Whether it's <span className="font-semibold">feeding the
            hungry, educating underprivileged children, or providing healthcare,</span>
            KWF ensures your generosity makes a significant, tangible impact.
          </div>
          <Link
            className="primary-button w-max md:!mt-8 !mt-4"
            data-track-cta="Get started"
            to="/donation"
            onClick={()=>scrollToTop()}
          >
            Make a Difference Today
          </Link>
        </div>
      </div>
    </div>
  );
};
